import '../styling/global.css';
import myGif from '../assets/aboutus.gif';
import img1 from '../assets/9.webp';
import img2 from '../assets/10.webp';
import img3 from '../assets/7.webp';
import img4 from '../assets/8.webp';
import img5 from '../assets/11.webp';
import BackgroundEffect from '../components/BackgroundEffect';


const teamMembers = [
    {
        img: img1,
        name: 'Jangam Vazrakar',
        description: 'CEO / Director / Founder',
    },
    {
        img: img2,
        name: 'Manchala Divya',
        description: 'Director / HR Manager',
    },
    {
        img: img3,
        name: 'Jangam Madhukar',
        description: 'Head of AI Department',
    },
    {
        img: img5,
        name: 'Manchala S. Chakravarthy',
        description: 'Project Lead Manager',
    },
    {
        img: img4,
        name: 'Nakka Brahmanaidu',
        description: 'Branch Incharge',
    }
];

const AboutUs = () => {
    return (
        <div className="about-us">
            <BackgroundEffect />
            <section className="about-hero">
                <h1>About Us </h1>
            </section>

            <section className="about-content">
                <div className="about-text">
                    <h2>Our Story</h2>
                    <p>
                        Over the years, JSKM Technologies has built strong relationships with diverse clients through transparency, innovation, and practicality.
                        With 16+ years of professional experience, we have made remarkable progress — a journey we are committed to taking even further.
                        We believe in our vision and consistently strive to reach out to you, because you are valuable to us.
                    </p><br />
                    <p>
                        At JSKM Technologies, it is an honor for every member of our team to serve you. We are dedicated to proving our commitment to excellence, helping your business grow with integrity and innovation.
                    </p>
                </div>
                <div className='image-div'>
                    <img src={myGif} alt="My GIF" className='gif-image' />
                </div>
                <div className="about-values">
                    <h2>Our Motto</h2>
                    <p>
                        “We work with the motto of providing the depth of research in time.” <br /><br />Founded on September 2nd, 2025, in Vijayawada, JSKM Technologies Private Limited was established under the leadership of Mr. Jangam Vazrakar, our Founder and CEO. His vision began during his time at NIT Jalandhar, where he aspired to empower organizations through web-based information and outsourcing services.
                        That vision has grown into today’s trusted and forward-thinking company. JSKM Technologies stands as a strong and evolving name in the IT industry in 2025.
                    </p>
                </div>

                <div className="about-team">
                    <h2>Team Members</h2>
                    <div className="team-grid">
                        {teamMembers.map((member, i) => (
                            <div className="team-member" key={i}>
                                <img src={member.img} alt={`Team Member ${i + 1}`} />
                                <h3>{member.name}</h3>
                                <p>{member.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutUs;
